import { initialState } from "./initialState";
import * as Types from "../action/type";

const reducer = (state = { initialState, article: [], admin: [] }, action) => {
  switch (action.type) {
    case Types.ARTICLESET:
      let items = action.payload;
      let isExits = state.article.find((item) => item === items);
      if (isExits) {
        let updated = state.article.map((i) => (i === isExits ? items : ""));
        return {
          ...state,
          article: [...state, updated],
        };
      }
      return {
        ...state,
        article: [...state.article, action.payload],
      };
    case Types.ADMINSET:
      let admins = action.payload;
      let isAdminExits = state.admin.find((item) => item === admins);
      if (isAdminExits) {
        let updated = state.admin.map((i) =>
          i === isAdminExits ? admins : ""
        );
        return {
          ...state,
          admin: [...state, updated],
        };
      }
      return {
        ...state,
        admin: [...state.admin, action.payload],
      };
    case Types.RESETALL:
      return {
        ...state,
        admin: [],
        article: [],
      };
    default:
      return state;
  }
};
export default reducer;
